import {
  FETCH_AI_WALLETS,
  FETCH_AI_WALLETS_SUCCESS,
  FETCH_AI_WALLETS_FAILURE,
  //
  FETCH_AI_LEDGER,
  FETCH_AI_LEDGER_SUCCESS,
  FETCH_AI_LEDGER_FAILURE,
} from "./constants";

//
export const fetchAiWallets = (payload) => ({
  type: FETCH_AI_WALLETS,
  payload,
});
export const fetchAiWalletsSuccess = (payload) => ({
  type: FETCH_AI_WALLETS_SUCCESS,
  payload,
});
export const fetchAiWalletsFailure = (payload) => ({
  type: FETCH_AI_WALLETS_FAILURE,
  payload,
});

// append=true appends the page to the existing ledger (load-more); else replaces.
export const fetchAiLedger = (payload, append = false) => ({
  type: FETCH_AI_LEDGER,
  payload,
  append,
});
export const fetchAiLedgerSuccess = (payload, append = false) => ({
  type: FETCH_AI_LEDGER_SUCCESS,
  payload,
  append,
});
export const fetchAiLedgerFailure = (payload, append = false) => ({
  type: FETCH_AI_LEDGER_FAILURE,
  payload,
  append,
});
